var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14ffa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15e584"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(-1103 -989)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 60,
    height: 60,
    rx: 20,
    transform: "translate(1103 989)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_8685554_ic_fluent_bot_filled_icon",
    "data-name": "8685554_ic_fluent_bot_filled_icon",
    transform: "translate(1113.902 997.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M30.354,11.5A4.342,4.342,0,0,1,34.7,15.845V17.5h-.013a8.449,8.449,0,0,1-2.695,6.132c-2.294,2.093-6.254,3.462-12.891,3.462S8.5,25.725,6.207,23.632A8.448,8.448,0,0,1,3.513,17.5H3.5V15.845A4.342,4.342,0,0,1,7.842,11.5Z",
    transform: "translate(0 13.302)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M8.6,4.4A3.6,3.6,0,0,0,5,8v9.6a3.6,3.6,0,0,0,3.6,3.6H25.4A3.6,3.6,0,0,0,29,17.6V8a3.6,3.6,0,0,0-3.6-3.6H18.2V3.2A1.153,1.153,0,0,0,17,2a1.21,1.21,0,0,0-1.2,1.2V4.4Zm1.2,8.4a2.4,2.4,0,1,1,2.4,2.4A2.4,2.4,0,0,1,9.8,12.8Zm9.6,0a2.4,2.4,0,1,1,2.4,2.4A2.4,2.4,0,0,1,19.4,12.8Z",
    transform: "translate(2.1 0)",
    fill: "#117446"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotIcon);
export default __webpack_public_path__ + "static/media/robotIcon.c37d59d399dc3bb53545f1833afd092c.svg";
export { ForwardRef as ReactComponent };